exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-decoration-4{position:relative;width:100%;height:100%}.dv-decoration-4 .container{display:-ms-flexbox;display:flex;overflow:hidden;position:absolute;-ms-flex:1;flex:1}.dv-decoration-4 .normal{animation:ani-height ease-in-out infinite;left:50%;margin-left:-2px}.dv-decoration-4 .reverse{animation:ani-width ease-in-out infinite;top:50%;margin-top:-2px}@keyframes ani-height{0%{height:0%}70%{height:100%}to{height:100%}}@keyframes ani-width{0%{width:0}70%{width:100%}to{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/decoration4/src/main.css
// module id = 1090
// module chunks = 45